module.exports = __webpack_public_path__ + "img/ai_img2img.7fada4d.png";